// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"g0-z","smallCardRow":"h0-z","largeCardRow":"i0-z","productSearchRow":"j0-z","curatedRow":"k0-z"};